/**
 * <payment-options> — keeps the per-installment amount in sync with the
 * selected variant. Listens for the theme-wide variant-change event and
 * recomputes price / installments on the client.
 */
if (!customElements.get("payment-options")) {
  class PaymentOptions extends HTMLElement {
    connectedCallback() {
      this.priceEl = this.querySelector(".js-payment-options-price");
      this.installments = parseInt(this.dataset.installments, 10) || 4;

      if (!this.priceEl || typeof subscribe !== "function") return;

      this.unsubscribe = subscribe(
        PUB_SUB_EVENTS.variantChange,
        this.onVariantChange.bind(this)
      );
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    onVariantChange(event) {
      const variant = event?.data?.variant;
      if (!variant || typeof variant.price !== "number") return;

      const perInstallment = Math.round(variant.price / this.installments);
      const moneyFormat = window.theme?.settings?.money_format;

      this.priceEl.textContent =
        typeof formatPrice === "function" && moneyFormat
          ? formatPrice(perInstallment, moneyFormat)
          : (perInstallment / 100).toFixed(2);
    }
  }

  customElements.define("payment-options", PaymentOptions);
}
